import { createFileRoute, redirect } from '@tanstack/react-router';
import { cachedSession } from '@/lib/session';

// /settings opens İşletme for the Owner and Bildirimler for Staff (merchant screens §2 Redirects).
export const Route = createFileRoute('/settings/')({
  beforeLoad: ({ context }) => {
    const owner = cachedSession(context)?.role === 'owner';
    throw redirect({ to: owner ? '/settings/business' : '/settings/notifications' });
  },
});
